<template>
  <div class="flex items-center justify-end gap-x-2">
    <div
      class="group cursor-pointer rounded-sm p-0.5 transition-all duration-200"
      :class="{
        'hover:bg-p-500 hover:shadow-blockedIcon': isClickable,
      }"
    >
      <slot>
        <div class="relative h-6 w-6">
          <CloseLock
            class="absolute h-full w-full shrink-0 transition-all group-hover:opacity-0"
            @click="openContactForm"
          />
          <OpenLock
            class="absolute h-full w-full shrink-0"
            @click="openContactForm"
          />
        </div>
      </slot>
    </div>
    <div class="flex shrink-0 gap-x-0.5">
      <div class="h-3 w-3 rounded-full bg-s-700" />
      <div class="h-3 w-3 rounded-full bg-s-700" />
      <div class="h-3 w-3 rounded-full bg-s-700" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getServices } from '~/constants/services'
import CloseLock from '~/assets/icons/close-lock.svg'
import OpenLock from '~/assets/icons/open-lock.svg'
import type { TRecord } from '~/src/types/common'

const props = defineProps<{
  initialFields: TRecord[] | string[]
}>()

const isClickable = computed(() => props.initialFields.length > 0)

const openContactForm = () => {
  if (!isClickable.value) return
  const initialValues = getServices([...props.initialFields])
  const { $modal } = useNuxtApp()
  $modal.setInitialFields(initialValues)
  $modal.open('contact')
}
</script>

<style scoped>
.lock-icon {
  box-shadow:
    0 3px 5px 0 rgb(0 0 0 / 20%),
    0 1px 18px 0 rgb(0 0 0 / 12%),
    0 6px 10px 0 rgb(0 0 0 / 14%);
}
</style>
